import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';

@Injectable({
  providedIn: 'root'
})
export class ExentoService {

  private API_URL;
  constructor(private http: HttpClient, private enviromentGlobalService: EnviromentGlobalService) {
		this.API_URL = enviromentGlobalService.apiUrl;
   }


GetRntExentoEstudioAutomatico(codigo_rnt: string): Observable<ResponseServiceModel> {
  return this.http.get<ResponseServiceModel>(`${this.API_URL}/RntsExento/ObtenerRntAplicarExento?codigo_rnt=${codigo_rnt}`).pipe(
    retry(2)
  );
}


CreateExentos(entry: any): Observable<ResponseServiceModel> {
  return this.http.post<ResponseServiceModel>(`${this.API_URL}/RntsExento/Crear`, entry).pipe(
    retry(2)
  );
}

GetListaExentos(numeroPagina: number, entry: any): Observable<ResponseServiceModel> {
  return this.http.post<ResponseServiceModel>(`${this.API_URL}/RntsExento/Obtener/0?PageNumber=${numeroPagina}&PageSize=100&QueryType=A`, entry).pipe(
      retry(2)
    );
}

update(entry: any): Observable<ResponseServiceModel> {
  return this.http.put<ResponseServiceModel>(`${this.API_URL}/RntsExento`, entry).pipe(
    retry(2)
  );
}

}
